import React from 'react'
import Files from './Files'
import { getMixedProps } from '../blockPublic'
import { genFileSizeDesc } from 'tyan/public'

export * from './fileServeStatus'

// const argsOfRender = { field, onChange, initValues, changedValues, defaultStyle, that }
const renderFiles = props => {
	const { field, defaultStyle } = props
	const { props: { key } } = getMixedProps('_files', [defaultStyle, field])

	return <Files key={key} {...props} />
}

export default renderFiles

export const genFileText = (name, ext, size, uploadPerson, uploadTime) => {
	// console.log('debug:', uploadPerson, uploadTime)
	const uploadInfo = []
	uploadPerson && uploadInfo.push(uploadPerson)
	uploadTime && uploadInfo.push(Tyan.Date.datetimeSecondString(uploadTime))
	return `${name}${ext} (${genFileSizeDesc(size)})${uploadInfo.length && ` (${uploadInfo.join(' ')})` || ''}`
}
